(function () {
  const initProductAccordion = () => {
    const accordionTitles = document.querySelectorAll(".about__accordion-title");
    
    accordionTitles.forEach((title) => {
      // Avoid double binding
      if (title.dataset.accordionBound) return;
      title.dataset.accordionBound = "true";

      title.addEventListener("click", function (event) {
        event.preventDefault();
        const item = title.closest(".about__accordion-item");
        if (!item) return;

        const desc = item.querySelector(".about__accordion-description");
        if (!desc) return;

        const isActive = title.classList.contains("active");

        // Close other accordions in the same container
        const container = item.closest(".pdp-accordions-container") || item.parentElement;
        container.querySelectorAll(".about__accordion-item").forEach((otherItem) => {
          if (otherItem === item) return;
          const otherTitle = otherItem.querySelector(".about__accordion-title");
          const otherDesc = otherItem.querySelector(".about__accordion-description");
          const otherBtn = otherItem.querySelector("button[aria-expanded]");

          if (otherTitle) otherTitle.classList.remove("active");
          if (otherDesc) {
            if (window.jQuery) {
              window.jQuery(otherDesc).stop().slideUp(300);
            } else {
              otherDesc.style.display = "none";
            }
          }
          if (otherBtn) otherBtn.setAttribute("aria-expanded", "false");
        });

        // Toggle current accordion
        const currentBtn = title.querySelector("button[aria-expanded]");
        if (isActive) {
          title.classList.remove("active");
          if (window.jQuery) {
            window.jQuery(desc).stop().slideUp(300);
          } else {
            desc.style.display = "none";
          }
          if (currentBtn) currentBtn.setAttribute("aria-expanded", "false");
        } else {
          title.classList.add("active");
          if (window.jQuery) {
            window.jQuery(desc).stop().slideDown(300);
          } else {
            desc.style.display = "block";
          }
          if (currentBtn) currentBtn.setAttribute("aria-expanded", "true");
        }
      });
    });
  };

  document.addEventListener("shopify:section:load", initProductAccordion);
  window.addEventListener("quickview:load", initProductAccordion);
  
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProductAccordion);
  } else {
    initProductAccordion();
  }
})();
